module.exports = {
  "zones": {
    "Pacific/Bougainville": ["z", {
      "wallclock": 1419732000000,
      "format": "+11",
      "abbrev": "+11",
      "offset": 39600000,
      "posix": 1419696000000,
      "save": 0
    }, {
      "wallclock": -768873600000,
      "format": "+10",
      "abbrev": "+10",
      "offset": 36000000,
      "posix": -768906000000,
      "save": 0
    }, {
      "wallclock": -867974400000,
      "format": "+09",
      "abbrev": "+09",
      "offset": 32400000,
      "posix": -868010400000,
      "save": 0
    }, {
      "wallclock": -2366755200000,
      "format": "+10",
      "abbrev": "+10",
      "offset": 36000000,
      "posix": -2366790512000,
      "save": 0
    }, {
      "wallclock": -2840140800000,
      "format": "PMMT",
      "abbrev": "PMMT",
      "offset": 35312000,
      "posix": -2840178136000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 37336000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};